import RestResource from '../rest.service';

export default class HarvestService extends RestResource {
  map(payload) {
    return {
      plot_id: payload.plotId,
      chop_date: payload.chopDate,
      chopper_machine: payload.chopperMachine,
      storage_performance: payload.storagePerformance,
      harvest_date: payload.harvestDate,
      plant_height: payload.plantHeight,
      spike_insertion: payload.spikeInsertion,
      harvest_performance: payload.harvestPerformance,
      has_inoculation: payload.hasInoculation,
      inoculant_brand: payload.inoculantBrand,
      comment: payload.comment,
    };
  }

  mapAttach(payload) {
    return {
      pictures: payload,
    };
  }

  constructor() {
    super('harvests');
  }
}
